var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.38281L11 15.3828M11 9.38281L17 15.3828M2.72 13.3428L7.04 19.1028C7.392 19.5721 7.568 19.8068 7.79105 19.9761C7.9886 20.126 8.21232 20.2378 8.45077 20.3059C8.72 20.3828 9.01334 20.3828 9.6 20.3828H17.2C18.8802 20.3828 19.7202 20.3828 20.362 20.0558C20.9265 19.7682 21.3854 19.3093 21.673 18.7448C22 18.103 22 17.263 22 15.5828V9.18281C22 7.50266 22 6.66258 21.673 6.02084C21.3854 5.45635 20.9265 4.99741 20.362 4.70979C19.7202 4.38281 18.8802 4.38281 17.2 4.38281H9.6C9.01334 4.38281 8.72 4.38281 8.45077 4.4597C8.21232 4.52781 7.9886 4.63966 7.79105 4.78956C7.568 4.95882 7.392 5.19348 7.04 5.66281L2.72 11.4228C2.46181 11.7671 2.33271 11.9392 2.28294 12.1282C2.23902 12.2951 2.23902 12.4705 2.28294 12.6374C2.33271 12.8264 2.46181 12.9986 2.72 13.3428Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearChat);
export default __webpack_public_path__ + "static/media/clearChat.431b4361470e28c1c30958c9dbdaa22f.svg";
export { ForwardRef as ReactComponent };